<template>
  <v-sheet class="px-3 py-3" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#E8F1F8'">
    <apexChart width="100%" height="338px" type="bar" :options="options" :series="series" class="liveTradeChart">
    </apexChart>
  </v-sheet>
</template>

<script>
export default {
  props: {
    trades: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      options: {
        chart: {
          id: "vuechart-example",
          type: "bar",
          height: "338px",
          theme: "dark",
          stacked: true,
        },
        xaxis: {
          categories: [],
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          labels: {
            style: {
              colors: ["#708AA7"],
              rotate: -45,
              rotateAlways: false
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: ["#708AA7"],
            },
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "20%",
            borderRadius: 2
          },
        },
        colors: ["#039de9", "#FF567F"],
        dataLabels: {
          enabled: false,
        },
        grid: {
          show: false,
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: function (val) {
              return val;
            }
          }
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          show: true,
          showForSingleSeries: true,
          customLegendItems: ["Buy", "Sale"],
          labels: {
            colors: ["#647E98"],
            useSeriesColors: false,
          },
          markers: {
            fillColors: ["#039de9", "#FF567F"],
            radius: 12,
          },
        },
      },
      series: [
        {
          name: 'Buy',
          data: []
        },
        {
          name: 'Sale',
          data: []
        }
      ],
    };
  },

  watch: {
    trades: {
      immediate: true,
      handler(newTrades) {
        this.processTradesData(newTrades);
      }
    }
  },

  methods: {
    processTradesData(trades) {
      if (!trades || !trades.length) return;

      const monthlyData = new Map();

      trades.forEach(trade => {
        const date = new Date(trade.Timestamp * 1000);
        const monthYear = `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getFullYear() % 100)}`;

        if (!monthlyData.has(monthYear)) {
          monthlyData.set(monthYear, { buy: 0, sell: 0 });
        }

        const counts = monthlyData.get(monthYear);
        if (trade.Action === 0) {
          counts.buy += 1;
        } else if (trade.Action === 1) {
          counts.sell += 1;
        }
      });

      const sortedMonths = Array.from(monthlyData.keys()).sort((a, b) => {
        const [monthA, yearA] = a.split('/').map(Number);
        const [monthB, yearB] = b.split('/').map(Number);
        return (yearA * 12 + monthA) - (yearB * 12 + monthB);
      });

      this.options = {
        ...this.options,
        xaxis: {
          ...this.options.xaxis,
          categories: sortedMonths
        }
      };

      this.series = [
        {
          name: 'Buy',
          data: sortedMonths.map(month => monthlyData.get(month).buy)
        },
        {
          name: 'Sale',
          data: sortedMonths.map(month => monthlyData.get(month).sell)
        }
      ];
    }
  }
};
</script>
